import { useEffect, useState } from "react";
import ElectricityCheckModal from "./modals/electricity/electricityCheckModal";
import OperationalCardUnit from "./components/operationalCardUnit";
import OperationalCardBuilding from "./components/operationalCardBuilding";
import FireSecurityBuildingCheckModal from "./modals/fire-security/fireSecurityBuildingCheckModal";
import FireSecurityUnitCheckModal from "./modals/fire-security/fireSecurityUnitCheckModal";
import EnergyPerformanceModal from "./modals/energy-performance/energyPerformanceModal";
import PermitsInfoModal from "./modals/regulatory-info/permitsInfoModal";
import WaterBuildingInfoCheckModal from "./modals/water-info/waterBuildingInfoCheckModal";
import CadastreInfoModal from "./modals/regulatory-info/cadastreInfoModal";
import SoilInfoModal from "./modals/regulatory-info/soilInfoModal";
import ElevatorInfoModal from "./modals/elevator/elevatorInfoModal";
import BuildingStabilityInfoModal from "./modals/stability/stabilityInfoModal";
import BuildingVisualInspectionModal from "./modals/visual-inspection/buildingVisualInspectionInfoModal";
import BuildingPlansInfoModal from "./modals/plans/buildingPlansInfoModal";
import UnitVisualInspectionModal from "./modals/visual-inspection/unitVisualInspectionModal";
import BuildingDangerousMaterialsModal from "./modals/visual-inspection/buildingDangerousMaterialsModal";
import BuildingOwnershipInfoModal from "./modals/ownership/buildingOwnershipInfoModal";
import BuildingEasementsModal from "./modals/ownership/buildingEasementsModal";
import BuildingTaxationInfoModal from "./modals/ownership/buildingTaxationModal";
import BuildingInsuranceInfoModal from "./modals/ownership/buildingInsuranceInfoModal";
import ConformityInfoModal from "./modals/conformity/conformityInfoModal";
import DevicesInfoModal from "./modals/devices/devicesInfoModal";
import ClimatisationModal from "./modals/climatisation/climatisationInfoModal";
import WaterUnitInfoCheckModal from "./modals/water-info/waterUnitInfoCheckModal";
import UnitDangerousMaterialsModal from "./modals/visual-inspection/unitDangerousMaterialsModal";

const OperationalCheckTable = ({ building, refreshBuilding }: any) => {
  const [isElectricityModalOpen, setIsElectricityModalOpen] = useState(false);
  const [isFireSecurityBuildingModalOpen, setIsFireSecurityBuildingModalOpen] =
    useState(false);
  const [isFireSecurityUnitModalOpen, setIsFireSecurityUnitModalOpen] =
    useState(false);
  const [isWaterBuildingInfoModalOpen, setIsWaterBuildingInfoModalOpen] =
    useState(false);
  const [isWaterUnitInfoModalOpen, setIsWaterUnitInfoModalOpen] =
    useState(false);
  const [isEnergyPerformanceModalOpen, setIsEnergyPerformanceModalOpen] =
    useState(false);
  const [isPermitsInfoModalOpen, setIsPermitsInfoModalOpen] = useState(false);
  const [isCadastreInfoModalOpen, setIsCadastreInfoModalOpen] = useState(false);
  const [isSoilInfoModalOpen, setIsSoilInfoModalOpen] = useState(false);
  const [isElevatorModalOpen, setElevatorModalOpen] = useState(false);
  const [
    isBuildingVisualInspectionModalOpen,
    setIsBuildingVisualInspectionModalOpen,
  ] = useState(false);
  const [isStabilityModalOpen, setIsStabilityModalOpen] = useState(false);
  const [isPlanModalOpen, setIsPlanModalOpen] = useState(false);
  const [selectedEntity, setSelectedEntity] = useState<any>(null);
  const [isUnitVisualInspectionModalOpen, setIsUnitVisualInspectionModalOpen] =
    useState(false);
  const [
    isBuildingDangerousMaterialsModalOpen,
    setIsBuildingDangerousMaterialsModalOpen,
  ] = useState(false);
  const [
    isBuildingOwnershipInfoModalOpen,
    setIsBuildingOwnershipInfoModalOpen,
  ] = useState(false);
  const [isBuildingEasementsModalOpen, setIsBuildingEasementsModalOpen] =
    useState(false);
  const [isBuildingTaxationModalOpen, setIsBuildingTaxationModalOpen] =
    useState(false);
  const [isBuildingInsuranceModalOpen, setIsBuildingInsuranceModalOpen] =
    useState(false);
  const [isUnitConformityInfoModalOpen, setIsUnitConformityInfoModalOpen] =
    useState(false);
  const [isUnitDevicesModalOpen, setIsUnitDevicesModalOpen] = useState(false);
  const [isClimatisationModalOpen, setIsClimatisationModalOpen] =
    useState(false);
  const [
    isUnitDangerousMaterialsModalOpen,
    setIsUnitDangerousMaterialsModalOpen,
  ] = useState(false);
  // const [selectedUnitIds, setSelectedUnitIds] = useState<any>({});

  // Due Diligence Modal State - Moved to dedicated "Due Diligence (Nieuw)" tab
  // const [isDueDiligenceModalOpen, setIsDueDiligenceModalOpen] = useState(false);
  // const [selectedDueDiligenceCategory, setSelectedDueDiligenceCategory] =
  //   useState<{
  //     categoryId: number;
  //     categoryName: string;
  //     buildingId?: string;
  //     unitId?: string;
  //   } | null>(null);

  // Reset modals when building changes
  useEffect(() => {
    // Close any open modals when building changes
    setIsElectricityModalOpen(false);
    setIsFireSecurityBuildingModalOpen(false);
    setIsFireSecurityUnitModalOpen(false);
    setIsWaterBuildingInfoModalOpen(false);
    setIsWaterUnitInfoModalOpen(false);
    setIsEnergyPerformanceModalOpen(false);
    setIsPermitsInfoModalOpen(false);
    setIsCadastreInfoModalOpen(false);
    setIsSoilInfoModalOpen(false);
    setElevatorModalOpen(false);
    setIsBuildingVisualInspectionModalOpen(false);
    setIsStabilityModalOpen(false);
    setIsPlanModalOpen(false);
    setIsUnitVisualInspectionModalOpen(false);
    setIsBuildingDangerousMaterialsModalOpen(false);
    setIsBuildingOwnershipInfoModalOpen(false);
    setIsBuildingEasementsModalOpen(false);
    setIsBuildingTaxationModalOpen(false);
    setIsBuildingInsuranceModalOpen(false);
    setIsUnitConformityInfoModalOpen(false);
    setIsUnitDevicesModalOpen(false);
    setIsClimatisationModalOpen(false);
    setIsUnitDangerousMaterialsModalOpen(false);
    // setIsDueDiligenceModalOpen(false); // Moved to "Due Diligence (Nieuw)" tab
    // Clear selected entity when building changes
    setSelectedEntity(null);
    // setSelectedDueDiligenceCategory(null); // Moved to "Due Diligence (Nieuw)" tab
  }, [building?.id]); // Dependency on building ID ensures this runs when building changes

  // Due Diligence handlers - Moved to dedicated "Due Diligence (Nieuw)" tab
  // const handleDueDiligenceCategoryClick = (
  //   category: CategoryDotValues,
  //   buildingId?: string,
  //   unitId?: string,
  // ) => {
  //   setSelectedDueDiligenceCategory({
  //     categoryId: category.categoryId,
  //     categoryName: category.categoryName,
  //     buildingId,
  //     unitId,
  //   });
  //   setIsDueDiligenceModalOpen(true);
  // };

  // const _handleDueDiligenceQuestionClick = (
  //   category: CategoryDotValues,
  //   _question: QuestionDotValue,
  //   buildingId?: string,
  //   unitId?: string,
  // ) => {
  //   handleDueDiligenceCategoryClick(category, buildingId, unitId);
  // };

  // const handleDueDiligenceModalClose = () => {
  //   setIsDueDiligenceModalOpen(false);
  //   setSelectedDueDiligenceCategory(null);
  //   refreshBuilding();
  // };

  const handleUnitCellClick = (unit: any, header: any) => {
    if (header === "Elektriciteit") {
      handleElectricityCellClick(unit);
    }
    if (header === "Woonconformiteit") {
      handleUnitConformityCellClick(unit);
    }
    if (header == "Brandveiligheid") {
      handleFireSecurityUnitCellClick(unit);
    }
    if (header == "Gevaarlijke stoffen") {
      handleUnitDangerousMaterialsCellClick(unit);
    }
    if (header === "Energieprestaties") {
      handleEnergyPerformanceCellClick(unit);
    }
    if (header === "Vis. inspectie") {
      handleUnitVisualInspectionCellClick(unit);
    }
    if (header == "Toestellen") {
      handleUnitDevicesCellClick(unit);
    }
    if (header === "Waterhuishouding") {
      handleWaterUnitInfoCellClick(unit);
    }
    if (header == "Klimatisatie") {
      handleClimatisationCellClick(unit);
    }
    if (header == "Gevaarlijke stoffen") {
      handleUnitDangerousMaterialsCellClick(unit);
    }
    // Add more conditions here for other categories if needed
  };
  const handleUnitVisualInspectionCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsUnitVisualInspectionModalOpen(true);
  };
  const handleUnitConformityCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsUnitConformityInfoModalOpen(true);
  };
  const handleClimatisationCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsClimatisationModalOpen(true);
  };
  const handleBuildingCellClick = (building: any, header: any) => {
    console.log(building);
    console.log(header);
    if (header === "Elektriciteit") {
      handleElectricityCellClick(building);
    }
    if (header === "Klimatisatie") {
      handleClimatisationCellClick(building);
    }
    if (header === "Brandveiligheid") {
      handleFireSecurityBuildingCellClick(building);
    }
    if (header === "Waterhuishouding") {
      handleWaterBuildingInfoCellClick(building);
    }
    if (header === "Energieprestaties") {
      handleEnergyPerformanceCellClick(building);
    }
    if (header == "Stedenbouw") {
      handlePermitsInfoCellClick(building);
    }
    if (header == "Kadaster") {
      handleCadastreInfoCellClick(building);
    }
    if (header == "Bodem") {
      handleSoilInfoCellClick(building);
    }
    if (header == "Lift") {
      handleElevatorCellClick(building);
    }
    if (header == "Stabiliteit") {
      handleStabilityCellClick(building);
    }
    if (header == "Vis. inspectie") {
      handleVisualInspectionCellClick(building);
    }
    if (header == "Plannen") {
      handlePlanCellClick(building);
    }
    if (header == "Gevaarlijke stoffen") {
      handleDangerousMaterialsCellClick(building);
    }
    if (header == "Eigendom") {
      handleBuildingOwnershipCellClick(building);
    }
    if (header == "Erfdienstbaarheden") {
      handleBuildingEasementsCellClick(building);
    }
    if (header == "Taxatie") {
      handleBuildingTaxationCellClick(building);
    }
    if (header == "Verzekeringen") {
      handleBuildingInsuranceCellClick(building);
    }
    // Add more conditions here for other categories if needed
  };
  const handleUnitDevicesCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsUnitDevicesModalOpen(true);
  };
  const handleBuildingInsuranceCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsBuildingInsuranceModalOpen(true);
  };
  const handleBuildingTaxationCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsBuildingTaxationModalOpen(true);
  };
  const handleBuildingOwnershipCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsBuildingOwnershipInfoModalOpen(true);
  };
  const handleBuildingEasementsCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsBuildingEasementsModalOpen(true);
  };
  const handleDangerousMaterialsCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsBuildingDangerousMaterialsModalOpen(true);
  };
  const handleUnitDangerousMaterialsCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsUnitDangerousMaterialsModalOpen(true);
  };
  const handlePlanCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsPlanModalOpen(true);
  };
  const handleStabilityCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsStabilityModalOpen(true);
  };
  const handleVisualInspectionCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsBuildingVisualInspectionModalOpen(true);
  };
  const handleElevatorCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setElevatorModalOpen(true);
  };
  const handleElectricityCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsElectricityModalOpen(true);
  };
  const handleEnergyPerformanceCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsEnergyPerformanceModalOpen(true);
  };
  const handleEnergyPerformanceModalClose = () => {
    setIsEnergyPerformanceModalOpen(false);
    handleModalClose();
  };
  const handlePermitsInfoCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsPermitsInfoModalOpen(true);
  };
  const handleSoilInfoCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsSoilInfoModalOpen(true);
  };
  const handlePermitsInfoModalClose = () => {
    setIsPermitsInfoModalOpen(false);
    handleModalClose();
  };
  const handleFireSecurityBuildingCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsFireSecurityBuildingModalOpen(true);
  };
  const handleCadastreInfoCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsCadastreInfoModalOpen(true);
  };
  const handleWaterBuildingInfoCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsWaterBuildingInfoModalOpen(true);
  };
  const handleWaterUnitInfoCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsWaterUnitInfoModalOpen(true);
  };
  const handleFireSecurityUnitCellClick = (entity: any) => {
    setSelectedEntity(entity);
    setIsFireSecurityUnitModalOpen(true);
  };
  const handleModalClose = () => {
    setSelectedEntity(null);
    refreshBuilding(); // Trigger table refresh
  };
  const createModalCloseHandler = (setModalOpen: any) => () => {
    setModalOpen(false);
    handleModalClose();
  };
  const handleElectricityModalClose = createModalCloseHandler(
    setIsElectricityModalOpen,
  );
  const handleBuildingOwnershipInfoModalClose = createModalCloseHandler(
    setIsBuildingOwnershipInfoModalOpen,
  );
  const handleFireSecurityBuildingModalClose = createModalCloseHandler(
    setIsFireSecurityBuildingModalOpen,
  );
  const handleSoilInfoModalClose = createModalCloseHandler(
    setIsSoilInfoModalOpen,
  );
  const handleWaterBuildingInfoModalClose = createModalCloseHandler(
    setIsWaterBuildingInfoModalOpen,
  );
  const handleWaterUnitInfoModalClose = createModalCloseHandler(
    setIsWaterUnitInfoModalOpen,
  );
  const handleClimatisationModalClose = createModalCloseHandler(
    setIsClimatisationModalOpen,
  );
  const handleFireSecurityUnitModalClose = createModalCloseHandler(
    setIsFireSecurityUnitModalOpen,
  );
  const handleStabilityModalClose = createModalCloseHandler(
    setIsStabilityModalOpen,
  );
  const handleBuildingVisualInspectionClose = createModalCloseHandler(
    setIsBuildingVisualInspectionModalOpen,
  );
  const handleCadastreInfoModalClose = createModalCloseHandler(
    setIsCadastreInfoModalOpen,
  );
  const handleElevatorModalClose =
    createModalCloseHandler(setElevatorModalOpen);
  const handleBuildingDangerousMaterialsModalClose = createModalCloseHandler(
    setIsBuildingDangerousMaterialsModalOpen,
  );
  const handlePlanModalClose = createModalCloseHandler(setIsPlanModalOpen);
  const handleUnitVisualInspectionClose = createModalCloseHandler(
    setIsUnitVisualInspectionModalOpen,
  );
  const handleBuildingEasementsModalClose = createModalCloseHandler(
    setIsBuildingEasementsModalOpen,
  );
  const handleBuildingTaxationModalClose = createModalCloseHandler(
    setIsBuildingTaxationModalOpen,
  );
  const handleUnitConformityInfoModalClose = createModalCloseHandler(
    setIsUnitConformityInfoModalOpen,
  );
  const handleUnitDevicesModalClose = createModalCloseHandler(
    setIsUnitDevicesModalOpen,
  );
  const handleUnitDangerousMaterialsModalClose = createModalCloseHandler(
    setIsUnitDangerousMaterialsModalOpen,
  );
  const handleBuildingInsuranceModalClose = createModalCloseHandler(
    setIsBuildingInsuranceModalOpen,
  );
  const buildingColumnHeaders: any = {
    Technisch: [
      "Brandveiligheid",
      "Energieprestaties",
      "Gevaarlijke stoffen", //Asbest, koelvloeistoffen, ...
      "Elektriciteit",
      "Klimatisatie",
      "Lift",
      "Plannen",
      "Stabiliteit",
      "Vis. inspectie", // Waterschade, schimmel, regenafvoer, deurbel,...
      "Waterhuishouding", // Riolering, septische put
    ],
    Juridisch: [
      "Bodem",
      "Eigendom",
      "Erfdienstbaarheden",
      "Kadaster",
      "Litiges",
      "Stedenbouw",
      "Taxatie",
      "Verzekeringen",
    ],
    Commercieel: ["Yally verbeteringen", "Website"],
  };
  const unitColumnHeaders: any = {
    Technisch: [
      "Brandveiligheid",
      "Energieprestaties",
      "Gevaarlijke stoffen",
      "Elektriciteit",
      "Klimatisatie",
      "Toestellen",
      "Vis. inspectie",
      "Waterhuishouding",
    ],
    Juridisch: ["Woonconformiteit"],
    // Verhuur: [
    //   "Huurder", // ID, bewijs van inkomen
    //   "Huurcontract", // ingaande plaatsbeschrijving, reglement van inwendige orde
    //   "Plaatsbeschrijving",
    //   "Huurdersverplichtingen", // Kuisen gang, reinigen septische put, elektrische keuring (handelshuur)
    //   "Huurdersverzekering", // Brandverzekering
    //   "Huurbetalingen",
    //   "Waarborg",
    //   "Status",
    //   "Whise",
    // ],
    Commercieel: [],
  };
  const renderCards = () => {
    // Check if building exists and has an ID before rendering
    if (!building || !building.id) {
      return (
        <div className="flex items-center justify-center py-8">
          <p className="text-neutral-secondary-mid">
            Geen gegevens beschikbaar
          </p>
        </div>
      );
    }

    const sortedUnits =
      Array.isArray(building?.units) && building.units.length > 0
        ? [...building.units].sort((a, b) => a.id.localeCompare(b.id))
        : [];

    return (
      <div className="flex flex-col gap-8">
        {/* Hardcoded Operational Checks */}
        <section className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          <div className="row-span-2">
            <OperationalCardBuilding
              building={building}
              categories={buildingColumnHeaders}
              onCellClick={handleBuildingCellClick}
            />
          </div>
          {sortedUnits.map((unit: any) => (
            <OperationalCardUnit
              key={unit.id}
              unit={unit}
              categories={unitColumnHeaders}
              onCellClick={handleUnitCellClick}
            />
          ))}
        </section>

        {/* Configurable Due Diligence Section */}
        {/*
        <section>
          <h3 className="text-lg font-semibold text-red-600 mb-4 flex items-center gap-2">
            <span className="w-3 h-3 bg-red-500 rounded-full" />
            Configureerbare Due Diligence Controles
          </h3>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">

            <DueDiligenceCard
              buildingId={building.id}
              title={`${building.id} - Due Diligence Gebouw`}
              scope={DueDiligenceScope.BUILDING}
              onCategoryClick={(cat) => handleDueDiligenceCategoryClick(cat, building.id)}
              onQuestionClick={(cat, q) => handleDueDiligenceQuestionClick(cat, q, building.id)}
            />


            {sortedUnits.map((unit: any) => (
              <DueDiligenceCard
                key={`dd-${unit.id}`}
                unitId={unit.id}
                title={`${unit.id} - Due Diligence`}
                scope={DueDiligenceScope.UNIT}
                onCategoryClick={(cat) => handleDueDiligenceCategoryClick(cat, undefined, unit.id)}
                onQuestionClick={(cat, q) => handleDueDiligenceQuestionClick(cat, q, undefined, unit.id)}
              />
            ))}
          </div>
        </section>
        */}
      </div>
    );
  };

  return (
    <div className="flex flex-col gap-8">
      {renderCards()}

      {selectedEntity && (
        <ElectricityCheckModal
          isOpen={isElectricityModalOpen}
          onClose={handleElectricityModalClose}
          building={building}
          unit={
            selectedEntity.unitType /* To check if it is a unit or a building */
              ? selectedEntity
              : null
          }
        />
      )}
      {selectedEntity && (
        <FireSecurityUnitCheckModal
          isOpen={isFireSecurityUnitModalOpen}
          onClose={handleFireSecurityUnitModalClose}
          unit={selectedEntity}
        />
      )}

      {selectedEntity && (
        <FireSecurityBuildingCheckModal
          isOpen={isFireSecurityBuildingModalOpen}
          onClose={handleFireSecurityBuildingModalClose}
          building={selectedEntity}
        />
      )}

      {selectedEntity && (
        <WaterBuildingInfoCheckModal
          isOpen={isWaterBuildingInfoModalOpen}
          onClose={handleWaterBuildingInfoModalClose}
          building={selectedEntity}
        />
      )}
      {selectedEntity && (
        <WaterUnitInfoCheckModal
          isOpen={isWaterUnitInfoModalOpen}
          onClose={handleWaterUnitInfoModalClose}
          unit={selectedEntity}
        />
      )}
      {selectedEntity && (
        <EnergyPerformanceModal
          isOpen={isEnergyPerformanceModalOpen}
          onClose={handleEnergyPerformanceModalClose}
          unit={selectedEntity.unitType ? selectedEntity : null}
          building={selectedEntity.unitType ? null : selectedEntity}
        />
      )}
      {selectedEntity && (
        <PermitsInfoModal
          isOpen={isPermitsInfoModalOpen}
          onClose={handlePermitsInfoModalClose}
          unit={selectedEntity.unitType ? selectedEntity : null}
          building={selectedEntity.unitType ? null : selectedEntity}
        />
      )}
      {selectedEntity && (
        <BuildingPlansInfoModal
          isOpen={isPlanModalOpen}
          onClose={handlePlanModalClose}
          unit={selectedEntity.unitType ? selectedEntity : null}
          building={selectedEntity.unitType ? null : selectedEntity}
        />
      )}
      {selectedEntity && (
        <CadastreInfoModal
          isOpen={isCadastreInfoModalOpen}
          onClose={handleCadastreInfoModalClose}
          unit={selectedEntity.unitType ? selectedEntity : null}
          building={selectedEntity.unitType ? null : selectedEntity}
        />
      )}
      {selectedEntity && (
        <SoilInfoModal
          isOpen={isSoilInfoModalOpen}
          onClose={handleSoilInfoModalClose}
          unit={selectedEntity.unitType ? selectedEntity : null}
          building={selectedEntity.unitType ? null : selectedEntity}
        />
      )}
      {selectedEntity && (
        <ElevatorInfoModal
          isOpen={isElevatorModalOpen}
          onClose={handleElevatorModalClose}
          unit={selectedEntity.unitType ? selectedEntity : null}
          building={selectedEntity.unitType ? null : selectedEntity}
        />
      )}
      {selectedEntity && (
        <BuildingStabilityInfoModal
          isOpen={isStabilityModalOpen}
          onClose={handleStabilityModalClose}
          unit={selectedEntity.unitType ? selectedEntity : null}
          building={selectedEntity.unitType ? null : selectedEntity}
        />
      )}
      {selectedEntity && (
        <BuildingVisualInspectionModal
          isOpen={isBuildingVisualInspectionModalOpen}
          onClose={handleBuildingVisualInspectionClose}
          unit={selectedEntity.unitType ? selectedEntity : null}
          building={selectedEntity.unitType ? null : selectedEntity}
        />
      )}
      {selectedEntity && (
        <UnitVisualInspectionModal
          isOpen={isUnitVisualInspectionModalOpen}
          onClose={handleUnitVisualInspectionClose}
          unit={selectedEntity.unitType ? selectedEntity : null}
          building={selectedEntity.unitType ? null : selectedEntity}
        />
      )}
      {selectedEntity && (
        <BuildingDangerousMaterialsModal
          isOpen={isBuildingDangerousMaterialsModalOpen}
          onClose={handleBuildingDangerousMaterialsModalClose}
          unit={selectedEntity.unitType ? selectedEntity : null}
          building={selectedEntity.unitType ? null : selectedEntity}
        />
      )}
      {selectedEntity && (
        <BuildingOwnershipInfoModal
          isOpen={isBuildingOwnershipInfoModalOpen}
          onClose={handleBuildingOwnershipInfoModalClose}
          unit={selectedEntity.unitType ? selectedEntity : null}
          building={selectedEntity.unitType ? null : selectedEntity}
        />
      )}
      {selectedEntity && (
        <BuildingEasementsModal
          isOpen={isBuildingEasementsModalOpen}
          onClose={handleBuildingEasementsModalClose}
          unit={selectedEntity.unitType ? selectedEntity : null}
          building={selectedEntity.unitType ? null : selectedEntity}
        />
      )}
      {selectedEntity && (
        <BuildingTaxationInfoModal
          isOpen={isBuildingTaxationModalOpen}
          onClose={handleBuildingTaxationModalClose}
          unit={selectedEntity.unitType ? selectedEntity : null}
          building={selectedEntity.unitType ? null : selectedEntity}
        />
      )}
      {selectedEntity && (
        <BuildingInsuranceInfoModal
          isOpen={isBuildingInsuranceModalOpen}
          onClose={handleBuildingInsuranceModalClose}
          unit={selectedEntity.unitType ? selectedEntity : null}
          building={selectedEntity.unitType ? null : selectedEntity}
        />
      )}
      {selectedEntity && (
        <ConformityInfoModal
          isOpen={isUnitConformityInfoModalOpen}
          onClose={handleUnitConformityInfoModalClose}
          unit={selectedEntity.unitType ? selectedEntity : null}
          building={selectedEntity.unitType ? null : selectedEntity}
        />
      )}
      {selectedEntity && (
        <DevicesInfoModal
          isOpen={isUnitDevicesModalOpen}
          onClose={handleUnitDevicesModalClose}
          unit={selectedEntity.unitType ? selectedEntity : null}
          building={selectedEntity.unitType ? null : selectedEntity}
        />
      )}
      {selectedEntity && (
        <ClimatisationModal
          isOpen={isClimatisationModalOpen}
          onClose={handleClimatisationModalClose}
          unit={selectedEntity.unitType ? selectedEntity : null}
          building={selectedEntity.unitType ? null : selectedEntity}
        />
      )}
      {selectedEntity && (
        <UnitDangerousMaterialsModal
          isOpen={isUnitDangerousMaterialsModalOpen}
          onClose={handleUnitDangerousMaterialsModalClose}
          unit={selectedEntity}
        />
      )}

      {/* Due Diligence Response Modal - Moved to dedicated "Due Diligence (Nieuw)" tab */}
      {/* {selectedDueDiligenceCategory && (
        <DueDiligenceResponseModal
          isOpen={isDueDiligenceModalOpen}
          onClose={handleDueDiligenceModalClose}
          categoryId={selectedDueDiligenceCategory.categoryId}
          categoryName={selectedDueDiligenceCategory.categoryName}
          buildingId={selectedDueDiligenceCategory.buildingId}
          unitId={selectedDueDiligenceCategory.unitId}
        />
      )} */}
    </div>
  );
};

export default OperationalCheckTable;
